// @ts-nocheck
import card1 from "../assets/card1.png";
import card2 from "../assets/card2.png";
import card3 from "../assets/card3.png";

export const generalData = [
  {
    id: 1,
    title: "Lorem ipsum ",
    author: "Hüsnü Taner ",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus suscipit magna dui, eget ultrices dui euismod in.",
    date: "10.09.2020 - 10.10.2020",
    image: card1,
  },
  {
    id: 2,
    title: "Nulla semper metus",
    author: "Mustafa Serkan Tiryaki",
    content:
      "Nulla semper metus aliquam, condimentum odio vitae, sodales mauris. Donec congue leo eu libero ultricies tempor. Duis commodo lacus eget felis volutpat molestie. Sed at pharetra mauris. Ut eu lorem placerat, tempus velit in, feugiat libero.",
    date: "10.09.2020 - 10.10.2020",
    image: card2,
  },
  {
    id: 3,
    title: "Suspendisse tempus dignissim lacus ac tincidunt",
    author: "Kerim Değirmenci ",
    content:
      "Nam semper sapien et erat molestie, a porttitor sem volutpat. Suspendisse tempus dignissim lacus ac tincidunt. Donec elementum pharetra orci, nec laoreet felis facilisis nec. Mauris ornare fermentum urna. Nunc non elit metus. Praesent sodales in nisi eget volutpat.",
    date: "10.09.2020 - 10.10.2020",
    image: card3,
  },
  {
    id: 4,
    title: "Integer dignissim ",
    author: "Ebu Bekir Behram ",
    content:
      "Integer nec vulputate libero. Donec at sollicitudin nibh. Nullam viverra egestas lorem, sed aliquet risus efficitur eu. Nunc tristique nisi ac massa finibus, sit amet blandit lectus suscipit. Mauris quis faucibus lorem. Integer dignissim condimentum orci, vitae pellentesque felis eleifend ac.",
    date: "10.09.2020 - 10.10.2020",
    image: card1,
  },
  {
    id: 5,
    title: "Suspendisse tempus dignissim lacus ac tincidunt",
    author: "Kerim Değirmenci ",
    content:
      "Nam semper sapien et erat molestie, a porttitor sem volutpat. Suspendisse tempus dignissim lacus ac tincidunt. Donec elementum pharetra orci, nec laoreet felis facilisis nec. Mauris ornare fermentum urna. Nunc non elit metus. Praesent sodales in nisi eget volutpat.",
    date: "10.09.2020 - 10.10.2020",
    image: card2,
  },
  {
    id: 6,
    title: "Integer dignissim ",
    author: "Ebu Bekir Behram ",
    content:
      "Integer nec vulputate libero. Donec at sollicitudin nibh. Nullam viverra egestas lorem, sed aliquet risus efficitur eu. Nunc tristique nisi ac massa finibus, sit amet blandit lectus suscipit. Mauris quis faucibus lorem. Integer dignissim condimentum orci, vitae pellentesque felis eleifend ac.",
    date: "10.09.2020 - 10.10.2020",
    image: card3,
  },
];
